<script>
export default {
    name: "IPDiagnosisReport",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        Promise.allSettled([ this.fetchIPDiagnosisReport(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },
    methods: {

        fetchIPDiagnosisReport() {

            let url = `PatientReports/GetInPatientDiagnosis?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.treatedBy ? `&TreatedBy=${this.$route.query.treatedBy}` : ``;
            return this.$http.get(url).then(response => {
                this.patients = response.data.patientDiagnosisReport;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">IP Diagnosis Report</h5>
        </div>
        <table class="table table-striped">
            <thead class="text-sm">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/6">Names</th>
                      <th class="p-tiny w-1/12">IPFileno</th>
                      <th class="p-tiny w-1/12">ID No</th>
                      <th class="p-tiny w-1/12">Date</th>
                      <th class="p-tiny w-1/12">Time</th>
                      <th class="p-tiny w-1/6">User</th>
                      <th class="p-tiny w-1/12">Discharged</th>
                      <th class="p-tiny w-1/12">Ward</th>
                      <th class="p-tiny w-1/12">Bed</th>
                      <th class="p-tiny w-1/6">Diagnosis</th>
                  </tr>
            </thead>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/6">{{ patient.names }}</td>
                    <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                    <td class="p-tiny w-1/12">{{ patient.opfileno }}</td>
                    <td class="p-tiny w-1/12">{{ patient.trxDate | dateFormat }}</td>
                    <td class="p-tiny w-1/12">{{ patient.timeAdmitted }}</td>
                    <td class="p-tiny w-1/6">{{ patient.admittedBy }}</td>
                    <td class="p-tiny w-1/12">{{ patient.discharged ? `Yes` : `No` }}</td>
                    <td class="p-tiny w-1/12">{{ patient.ward }}</td>
                    <td class="p-tiny w-1/12">{{ patient.bed }}</td>
                    <td class="p-tiny w-1/6">{{ patient.memo }}</td>
                </tr>
                <tr class="w-full flex">
                    <th class="p-tiny w-1/2"></th>
                    <th class="p-tiny w-1/2 text-right">Diagnosis Recorded: {{ patients.length }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</template>